import { Link } from "react-router-dom";
import { MessageCircle, Mail, MapPin } from "lucide-react";
import { Logo, Watermark } from "../brand/Logo";
import { NAV, waLink, WHATSAPP_DISPLAY, EMAIL } from "../../lib/site";

const CONTACTS = [
  { Icon: MessageCircle, label: WHATSAPP_DISPLAY, href: waLink(), id: "whatsapp" },
  { Icon: Mail, label: EMAIL, href: `mailto:${EMAIL}`, id: "email" },
  { Icon: MapPin, label: "Av. Copacabana, 177 - Alphaville - SP", id: "endereco" },
];

export const Footer = () => (
  <footer id="contato" className="relative scroll-mt-20 overflow-hidden bg-[#15579A] text-[#F7F5F0]" data-testid="site-footer">
    <Watermark className="-right-40 -top-24" />
    <div className="relative mx-auto grid max-w-7xl gap-12 px-5 py-20 sm:px-8 md:grid-cols-3">
      <div>
        <Logo variant="vertical" tone="white" />
        <p className="mt-8 font-serif text-xl italic text-[#F7F5F0]/80">O crédito certo.</p>
      </div>
      <nav aria-label="Rodapé">
        <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C8D7E4]">Navegação</h3>
        <ul className="mt-5 space-y-3">
          {NAV.map((n) => (
            <li key={n.id}><a href={`#${n.id}`} className="text-sm text-[#F7F5F0]/85 hover:text-white" data-testid={`footer-link-${n.id}`}>{n.label}</a></li>
          ))}
        </ul>
      </nav>
      <div>
        <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C8D7E4]">Contato</h3>
        <ul className="mt-5 space-y-3">
          {CONTACTS.map((c) => (
            <li key={c.id} className="flex items-center gap-3 text-sm text-[#F7F5F0]/85" data-testid={`footer-contact-${c.id}`}>
              <c.Icon className="h-4 w-4 shrink-0 text-[#218FFF]" strokeWidth={2.5} />
              {c.href ? <a href={c.href} {...(c.href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer" } : {})} className="hover:text-white">{c.label}</a> : c.label}
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="relative border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-5 py-6 text-xs text-[#F7F5F0]/60 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <p data-testid="footer-legal">As informações das cartas podem ser alteradas sem aviso prévio; valores sujeitos à confirmação no momento da negociação.</p>
        <div className="flex shrink-0 gap-4">
          <span>© {new Date().getFullYear()} Clube do Contemplado</span>
          <Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">Área restrita</Link>
        </div>
      </div>
    </div>
  </footer>
);
